export default __webpack_public_path__ + "static/media/0033.7671cdda.jpg";